import useGetData from 'hooks/useGetData'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import useSaga from 'hooks/useSaga'
import { takeEvery } from 'redux-saga/effects'
import { CHANNEL_DATA } from 'CHANNEL_DATA'
import Loader from 'components/Loader'

const makeChannelData = (onChannelData) => {
  return function * (action) {
    const { channel, actionName, elementName, data } = action.payload

    yield onChannelData({ channel, actionName, elementName, data })
  }
}

function * channelData (onChannelData) {
  const channelData = makeChannelData(onChannelData)

  yield takeEvery(CHANNEL_DATA, channelData)
}

const UserBlockers: React.FC<{
  children: (args: {
    cardBlockers: any[],
    isLoading: boolean;
    isLoaded: boolean;
  }) => React.ReactElement
}> = ({
  children
}) => {
  const [CardBlockers, setCardBlockers] = useState<any[]>([])

  const {
    data,
    fetch,
    isLoading,
    isLoaded,
  }: {
    data: any;
    fetch: () => void;
    isLoading: boolean;
    isLoaded: boolean;
  } = useGetData('MyCardBlockersImpact')

  useEffect(() => {
    if (data) {
      setCardBlockers(data.CardsImpact)
    }
  }, [data])

  const currentUserId = useSelector<any, number>(state => state.kanbo.currentUser.id)

  const handleChannelDataRef = useRef<(arg: any) => void>()

  useEffect(() => {
    handleChannelDataRef.current = ({ channel, actionName }) => {
      if (channel === `@${currentUserId}`) {
        if (
          actionName === 'AddBlockerToCard' ||
          actionName === 'RemoveBlockerFromCard' ||
          actionName === 'ChangeCardBlockerUser'
        ) {
          fetch()
        }
      }
    }
  }, [currentUserId, fetch])

  const handleChannelData = useCallback(
    (arg) => {
      handleChannelDataRef.current?.(arg)
    },
    []
  )

  useSaga(channelData, handleChannelData)

  const cardBlockers = useMemo(() => CardBlockers.map(CardBlocker => ({
    id: CardBlocker.Id,
    cardId: CardBlocker.CardId,
    name: CardBlocker.Name,
    description: CardBlocker.Description && JSON.parse(CardBlocker.Description),
    creationDate: CardBlocker.CreationDate,
    createdBy: CardBlocker.CreatedBy,
    reason: CardBlocker.Reason,
    userId: CardBlocker.UserId,
  })), [CardBlockers])

  return children({
    cardBlockers,
    isLoading,
    isLoaded,
  })
}

export default UserBlockers
